/* TheSunPays responsive tables (2026-10-19)
   Marks tables inside .rte or .tsp-table-scope so tsp-responsive-tables.css can
   show them as cards on phones. Tables inside .tsp-no-cards are left alone.
   Re-runs when new tables appear (e.g. the Pump Selector results). */
(function () {
  'use strict';

  var SCOPE = '.rte table, .tsp-table-scope table';

  function rowCells(row) {
    var out = [];
    for (var i = 0; i < row.children.length; i++) {
      var c = row.children[i];
      if (c.tagName === 'TD' || c.tagName === 'TH') out.push(c);
    }
    return out;
  }

  function colCount(row) {
    var n = 0;
    rowCells(row).forEach(function (c) { n += parseInt(c.getAttribute('colspan'), 10) || 1; });
    return n;
  }

  function cleanText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // A cell is "fully bold" when all its text sits inside <strong>/<b> (or it is a <th>).
  function isBoldCell(cell) {
    if (cell.tagName === 'TH') return true;
    var all = cleanText(cell);
    if (!all) return true;
    var bold = '';
    var marks = cell.querySelectorAll('strong, b');
    for (var i = 0; i < marks.length; i++) bold += marks[i].textContent;
    return bold.replace(/\s+/g, ' ').trim().length >= all.length - 1;
  }

  function headerRow(table, rows) {
    var thead = table.tHead;
    if (thead && thead.rows.length) return thead.rows[thead.rows.length - 1];
    var first = rows[0];
    if (!first) return null;
    var cells = rowCells(first);
    if (cells.length && cells.every(isBoldCell)) return first;
    return null;
  }

  // Safe to run again on the same table: rows added later (e.g. re-rendered
  // results) get their labels, existing labels are kept.
  function prepare(table) {
    if (table.closest('.tsp-no-cards')) return;
    var rows = Array.prototype.slice.call(table.rows);
    if (!rows.length) return;

    var cols = 0;
    rows.forEach(function (r) { cols = Math.max(cols, colCount(r)); });

    table.setAttribute('data-tsp-rt', '1');
    if (cols < 3) {
      table.classList.add('tsp-rt-2col');
      return;
    }
    table.classList.add('tsp-rt');

    var head = headerRow(table, rows);
    if (!head) return;
    head.classList.add('tsp-rt-head');

    // Header labels by column position (colspan aware)
    var labels = [];
    rowCells(head).forEach(function (c) {
      var span = parseInt(c.getAttribute('colspan'), 10) || 1;
      var t = cleanText(c);
      for (var s = 0; s < span; s++) labels.push(t);
    });

    rows.forEach(function (r) {
      if (r === head || (r.parentNode && r.parentNode.tagName === 'THEAD')) return;
      var pos = 0;
      rowCells(r).forEach(function (c) {
        var label = labels[pos];
        if (label && !c.hasAttribute('data-label')) c.setAttribute('data-label', label);
        pos += parseInt(c.getAttribute('colspan'), 10) || 1;
      });
    });
  }

  function run() {
    var tables = document.querySelectorAll(SCOPE);
    for (var i = 0; i < tables.length; i++) prepare(tables[i]);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; run(); });
  }

  function start() {
    run();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes && list[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
